module.exports = __webpack_public_path__ + "static/media/0.9fb7c202.jpg";